import { Layout, Showcase, Header, SectionTitle } from '../../../../components'
import { Link } from 'gatsby'

import React from 'react'
import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <SectionTitle>Usage</SectionTitle>
        <Showcase
          site={data.site}
          title="Inline Error"
          text="Inline errors are a filled container that appear below an input in the error state. They are directly attached to and affect the input field that requires correction. The message in the error container input will give the user clear direction on how to resolve the error."
          code={code.input}
        >
          <span class="c-inline-error">
            <i class="icon icon--error c-inline-error__icon"></i>
            <span class="c-inline-error__content">Error message here.</span>
          </span>
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>

        <Showcase
          site={data.site}
          text="Inline errors must always be used with an input in the error state."
        >
          <div>
            <input
              type="text"
              class="c-text-field c-inline-error__input"
              placeholder="e.g. Homer J. Simpson"
              id="input-1"
            />
            <span class="c-inline-error">
              <i class="icon icon--error c-inline-error__icon"></i>
              <span class="c-inline-error__content">
                Please enter your full name.
              </span>
            </span>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Inline errors should follow the guidelines for writing error messages
          detailed in the{' '}
          <Link className="link" to="/mt/guidelines/feedback-errors/design">
            feedback and errors
          </Link>{' '}
          page.
        </p>

        {/* <Showcase
          site={data.site}
          title="Inline Warning"
          text="Inline errors directly affect the input field that requires correction. The input's container will change color to draw the user's attention and a message below the input will give the user clear direction on how to resolve the error."
          code={code.warning}
        >
          <div>
            <label class="c-label" htmlFor="input-1">
              Label Name
            </label>
            <input
              type="text"
              class="c-text-field c-inline-error__input--warning"
              placeholder="e.g. Homer J. Simpson"
              id="input-1"
            />
            <span class="c-inline-error--warning">
              <i class="icon icon--exclamation c-inline-error__icon--warning"></i>
              <span class="c-inline-error__content">
                Please enter your full name.
              </span>
            </span>
          </div>
        </Showcase> */}
      </Layout>
    </>
  )
}

export const code = {
  /*
  input: `<label class="c-label">Label Name</label>
  <input type="text" class="c-text-field c-inline-error__input" placeholder="e.g. Homer J. Simpson" />
  <span class="c-inline-error">
      <i class="icon icon--exclamation c-inline-error__icon"></i>
      <span class="c-inline-error__content">
          Please enter your full name.
      </span>
  </span>
</div>
`,*/
}
